<template>
  <section class="menu_list">
    <v-icon @click="toggle">{{ icon }}</v-icon>
    <span
      >Seleccionar
      <SimpleMenu offset-x :items="Object.keys(groups)" v-model="group">
        <template #item="{ item }">
          {{ item.text }}
          <v-spacer></v-spacer>
          <v-chip class="ml-2" x-small>{{ groups[item.value].length }}</v-chip>
        </template>
      </SimpleMenu>
    </span>
  </section>
</template>

<script>
export default {
  name: "SelectableGroup",
  props: {
    groups: Object,
    value: String,
    isAllItemsSelected: Boolean,
    isSomeItemsSelected: Boolean
  },
  components: {
    SimpleMenu: () => import("../SimpleMenu.vue")
  },
  computed: {
    group: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    },
    icon() {
      if (this.isAllItemsSelected) return "mdi-close-box";
      if (this.isSomeItemsSelected) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    }
  },
  methods: {
    toggle() {
      this.$emit("toggle");
    }
  }
};
</script>
